import { Box, Flex, Grid } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { Color } from 'src/theme/color';
import { IData } from '../Chart/chart';

const LegendItem = ({
	active,
	noBorder,
	percent,
	color,
	price,
	percentHidden,
	label,
}: {
	active?: boolean;
	noBorder?: boolean;
	color?: string;
	percent?: number;
	price: number;
	label: string;
	percentHidden?: boolean;
}) => {
	return (
		<Grid
			padding="12px"
			borderRight={noBorder ? 'none' : '1px solid'}
			borderColor={Color.GRAY_1}
			bg={active ? Color.HASHUP : Color.BLACK_3}
			minW="130px"
			gap="6px"
		>
			<Flex
				alignItems="center"
				gap="6px"
			>
				<Box
					fontSize="12px"
					lineHeight="15px"
					fontStyle="regular"
				>
					{label}
				</Box>
				{color && (
					<Box
						bg={color}
						boxSize="10px"
						borderRadius="3px"
					/>
				)}
			</Flex>
			<Flex
				alignItems="flexEnd"
				gap="6px"
			>
				<Box
					fontSize="16px"
					lineHeight="16px"
					fontWeight="bold"
				>
					<Box
						color={active ? 'black' : 'white'}
						display="inline"
					>
						$
					</Box>
					{price.toFixed(2)}
				</Box>
				{!percentHidden && (
					<Box
						fontSize="12px"
						color={Color.GRAY_3}
					>
						{percent}%
					</Box>
				)}
			</Flex>
		</Grid>
	);
};

export const ChartLegend = ({ dataset, price }: { dataset: IData[]; price: number }) => {
	const { t } = useTranslation();
	return (
		<Flex
			mt="50px"
			border={`1px solid ${Color.GRAY_1}`}
			borderRadius="4px"
			overflow="hidden"
		>
			<LegendItem
				label={t('form.fields.price')}
				price={price}
				percentHidden
				active
			/>
			{dataset.map((item, index) => {
				return (
					<LegendItem
						noBorder={index == dataset.length - 1}
						key={item.label}
						label={item.label}
						color={item.color}
						percent={item.value}
						price={Number(price * (item.value / 100))}
					/>
				);
			})}
		</Flex>
	);
};
